/* eslint-disable @typescript-eslint/no-empty-function */
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'dcs-checkbox',
  templateUrl: './dcs-checkbox.component.html',
  styleUrls: ['./dcs-checkbox.component.scss'],
})
export class DcsCheckboxComponent implements OnInit {
  @Input()
  label: string;
  @Input()
  name: string;
  @Input()
  checked: boolean;
  @Output()
  onCheckboxChangeEvent: EventEmitter<boolean> = new EventEmitter();

  constructor() {}

  ngOnInit(): void {}

  onCheckboxChange($onCheckboxChange) {
    this.onCheckboxChangeEvent.emit($onCheckboxChange.detail.isChecked);
  }
}
